
import { useRef, useState } from 'react';
import { useFrame } from '@react-three/fiber';
import { DeviceOrientationControls } from '@react-three/drei';
import { Locations } from './Location';

export function DeviceOrientationControlsCustom({
	camera,
	needsReset = false, setNeedsReset = () => {},
}) {
	const deviceMotionControls = useRef();
	const [alphaOffset, setAlphaOffset] = useState(0);

	// On certain devices, the rotation needs to be offset at initializiation.
	// Since this can happen with a delay, we wait for the first orientation value.
	useFrame(() => {
		const deviceAlpha = deviceMotionControls.current.deviceOrientation.alpha;
		// && deviceAlpha - bc. alpha _might_ be 0 or undefined?
		if (needsReset && deviceAlpha) {
			setAlphaOffset(deviceAlpha);
			setNeedsReset(false);
		}

		// const offset = (Locations[location].azimuthAngle + alphaOffset) * (Math.PI / 180);
		// deviceMotionControls.current.alphaOffset = -offset;
	});

	return <DeviceOrientationControls
		ref={deviceMotionControls}
		camera={camera}
		makeDefault
	/>;
}
